import { actionTypes } from "./actionTypes";
export const setWidth = (width)=>({
    type: actionTypes.SET_WIDTH,
    width 
})